import React, { useEffect, useRef, useState } from 'react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import FormWizard from "react-form-wizard-component";
import "react-form-wizard-component/dist/style.css";
import { Link, useNavigate } from 'react-router-dom';
import Loader from '../landing/loder/Loader';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

import { PrivateAxios, PrivateAxiosFile } from '../../environment/AxiosInstance';
import { SuccessMessage } from '../../environment/ToastMessage';


function Register(props) {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const fileInputRef = useRef(null);

  // Company Info
  const [companyName, setCompanyName] = useState('');
  const [companyOwnerName, setCompanyOwnerName] = useState('');
  const [email, setEmail] = useState('');

  const [companyPhone, setCompanyPhone] = useState('');
  const [companyWhatsApp, setCompanyWhatsApp] = useState('');
  const [companyLogo, setCompanyLogo] = useState(null);

  const [errors, setErrors] = useState({});

  const handleInputChange = (e, setter) => {
    setter(e.target.value);
  };

  const handleFileChange = (e) => {
    setCompanyLogo(e.target.files[0]);
  };

  const handleButtonClick = () => {
    fileInputRef.current.click();
  };
  const validateForm = () => {
    const newErrors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const disposableDomains = [
      "tempmail.com", "10minutemail.com", "mailinator.com", "guerrillamail.com",
      "yopmail.com", "trashmail.com", "fakeinbox.com", "dispostable.com"
    ];

    if (!companyName.trim()) newErrors.companyName = "Company name is required";
    if (!companyOwnerName.trim()) newErrors.companyOwnerName = "Contact person name is required";

    if (!email.trim()) {
      newErrors.email = "Email is required";
    } else if (!emailRegex.test(email)) {
      newErrors.email = "Invalid email format";
    } else {
      const emailDomain = email.split('@')[1];
      if (disposableDomains.includes(emailDomain)) {
        newErrors.email = "Temporary email addresses are not allowed";
      }
    }

    if (!companyPhone.trim()) newErrors.companyPhone = "Phone number is required";
    if (!companyWhatsApp.trim()) newErrors.companyWhatsApp = "WhatsApp number is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const handleSubmit = async () => {
    if (!validateForm()) {
      return;
    }

    const data = new FormData();

    // Required fields (must match Node.js keys exactly)
    data.append('name', companyName);
    data.append('owner_name', companyOwnerName);
    data.append('email', email);
    data.append('phone', companyPhone.slice(2));
    data.append('whatsapp_no', companyWhatsApp.slice(2));
    data.append('start_date', new Date().toISOString());

    // ISD codes
    data.append('isd', '91');
    data.append('w_isd', '91');
    // Optional: logo
    if (companyLogo) {
      data.append('logo', companyLogo);
    }
    console.log(data, 'submit data');
    try {
      const response = await PrivateAxiosFile.post('/company/register', data);
      const companyId = response.data.data.id;

      localStorage.setItem('registered_company_id', companyId); // ✅ Save to localStorage
      SuccessMessage(response.data.msg);
      navigate('/modules');
    } catch (error) {
      alert(error?.response?.data?.msg || 'Something went wrong');
    }
  };

  useEffect(() => {
    setTimeout(() => setLoading(false), 1000);
  }, []);

  return (
    <>
      {loading && (
        <div className={`appie-loader ${loading ? 'active' : ''}`}>
          <Loader />
        </div>
      )}
      <div className={`appie-visible ${loading === false ? 'active' : ''}`}>
        <div className='login-auth-wrap'>
          <div className='container'>
            <div className='row justify-content-between align-items-center'>
              <div className='col-lg-5 col-md-6 col-sm-12'>
                <div className='loginBox'>
                  <div className="logo-wrap">
                    <a href="/"><img src={process.env.PUBLIC_URL + 'assets/images/logo-navy.png'} alt="Growthh" className='img-fluid' /></a>
                  </div>
                  <h1 className='login-title'>
                    Join our community and unlock a world of possibilities -
                    <span className='position-relative sign-in me-2'>
                      <span>SIGN UP!</span>
                      <svg viewBox="0 0 156 59" fill="none" xmlns="http://www.w3.org/2000/svg" className="fill-blue login-svg"><path d="M156 41C156 50.9411 147.89 58.735 138.408 55.7499C135.073 54.7001 131.284 53.8018 124.799 53.8018C109.2 53.8018 109.197 59 93.598 59C77.9988 59 77.9987 53.8018 62.3995 53.8018C46.8003 53.8018 46.7977 59 31.1985 59C24.7151 59 20.9263 58.102 17.5923 57.0526C8.1099 54.0677 0 45.7429 0 35.8018V18C0 8.05888 8.1099 0.265901 17.5923 3.2508C20.9263 4.30029 24.7151 5.19824 31.1985 5.19824C46.7977 5.19824 46.7977 0 62.3995 0C78.0013 0 77.9988 5.19824 93.598 5.19824C109.197 5.19824 109.197 0 124.799 0C131.284 0 135.073 0.898168 138.408 1.94782C147.89 4.93288 156 13.2571 156 23.1982V41Z" ></path></svg>
                    </span>
                  </h1>

                  <div className='card rounded-4'>
                    <div className='card-body'>
                      <div className='row'>
                        <div className='col-12'>
                          <div className="form-group">
                            <label className="form-label">Company Name <span className="text-danger">*</span></label>
                            <input type="text" className="form-control" placeholder="Company Name" value={companyName} onChange={(e) => handleInputChange(e, setCompanyName)} />
                            {errors.companyName && <div className="text-danger">{errors.companyName}</div>}
                          </div>
                        </div>
                        <div className='col-12'>
                          <div className="form-group">
                            <label className="form-label">Contact Person Name <span className="text-danger">*</span></label>
                            <input type="text" className="form-control" placeholder="Contact Person Name" value={companyOwnerName} onChange={(e) => handleInputChange(e, setCompanyOwnerName)} />
                            {errors.companyOwnerName && <div className="text-danger">{errors.companyOwnerName}</div>}
                          </div>
                        </div>
                        <div className='col-12'>
                          <div className="form-group">
                            <label className="form-label">Email <span className="text-danger">*</span></label>
                            <input type="email" className="form-control" placeholder="Your Email" value={email} onChange={(e) => handleInputChange(e, setEmail)} />
                            {errors.email && <div className="text-danger">{errors.email}</div>}
                          </div>
                        </div>

                        <div className='col-12'>
                          <div className="form-group">
                            <label className="form-label">Phone No.<span className="text-danger">*</span></label>
                            <PhoneInput
                              country={'in'}
                              value={companyPhone}
                              onChange={phone => setCompanyPhone(phone)}
                            />
                            {errors.companyPhone && <div className="text-danger">{errors.companyPhone}</div>}
                          </div>
                        </div>
                        <div className='col-12'>
                          <div className="form-group">
                            <label className="form-label">WhatsApp No.<span className="text-danger">*</span></label>
                            <PhoneInput
                              country={'in'}
                              value={companyWhatsApp}
                              onChange={phone => setCompanyWhatsApp(phone)}
                            />
                            {errors.companyWhatsApp && <div className="text-danger">{errors.companyWhatsApp}</div>}
                          </div>
                        </div>

                        <div className='col-12'>
                          <div className="form-group">
                            <label className="form-label">Company Logo</label>
                            <input type="file" ref={fileInputRef} onChange={handleFileChange} accept=".jpg,.png,.jpeg" style={{ display: 'none' }} />
                            <div>
                              <button className="btn btn-light border-dark" onClick={handleButtonClick}>Choose File</button>
                            </div>
                            {companyLogo && (
                              <div className="mt-2">
                                <img src={URL.createObjectURL(companyLogo)} alt="Company Logo" className="img-fluid" style={{ maxWidth: '200px' }} />
                              </div>
                            )}
                            {errors.companyLogo && <div className="text-danger">{errors.companyLogo}</div>}
                          </div>
                        </div>
                        <div className='text-end'>
                          <button className="btn btn-success" onClick={() => handleSubmit()}>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              xmlnsXlink="http://www.w3.org/1999/xlink"
                              version="1.1"
                              id="Capa_1"
                              x="0px"
                              y="0px"
                              viewBox="0 0 512.308 512.308"
                              style={{ enableBackground: "new 0 0 512.308 512.308" }}
                              xmlSpace="preserve"
                              width={14}
                              height={14}
                              fill="#ffffff"
                              className='me-2'
                            >
                              <g>
                                <path d="M505.878,36.682L110.763,431.69c8.542,4.163,17.911,6.351,27.413,6.4h67.669c5.661-0.015,11.092,2.236,15.083,6.251   l36.672,36.651c19.887,20.024,46.936,31.295,75.157,31.317c11.652-0.011,23.224-1.921,34.261-5.653   c38.05-12.475,65.726-45.46,71.403-85.099l72.085-342.4C513.948,64.89,512.311,49.871,505.878,36.682z" />
                                <path d="M433.771,1.652L92.203,73.61C33.841,81.628-6.971,135.44,1.047,193.802c3.167,23.048,13.782,44.43,30.228,60.885   l36.651,36.651c4.006,4.005,6.255,9.439,6.251,15.104v67.669c0.049,9.502,2.237,18.872,6.4,27.413L475.627,6.41   C462.645,0.03,447.853-1.651,433.771,1.652z" />
                              </g>
                            </svg>
                            SUBMIT
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
              <div className='col-lg-5 col-md-6 col-sm-12 login-right-col'>
                <div className='login-right-wrap'>
                  <div className='text-end imgBx'>
                    <img src={process.env.PUBLIC_URL + 'assets/images/login-right.webp'} alt="login" />
                  </div>
                  <div className='textBx'>
                    "Before Growthh, my to-do lists were scattered all around! Now, everything is in order and in one place."
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Register;
